import React from 'react';
import {Checkbox, Table} from "semantic-ui-react";
import TableStyled from "../../../components/Table/Table";
import SortIcon from "../../../components/Table/components/SortIcon";
import TableCellValueMassUpload from "../../../components/Table/components/TableCellValueMassUpload";

/**
 * Таблица для массовой загрузки с редактированием через модалки
 */
const MassUploadTableGrid = ({
    columns,
    rows,
    allParcels,
    fileId,
    selectedIds,
    onSelectChange,
    onSelectAll,
    canDeleteRows = true,
    onEditPositions,
    reload,
    loading = false,
    onBeforeEditOpen,
    onSaveEdit
}) => {
    const [sort, setSort] = React.useState(null);

    const handleSort = (fieldName) => {
        if (sort && sort.fieldName === fieldName) {
            setSort({
                fieldName,
                order: sort.order === 'asc' ? 'desc' : 'asc'
            });
        } else {
            setSort({fieldName, order: 'asc'});
        }
    };

    // Сортировка строк
    const sortedRows = React.useMemo(() => {
        if (!sort) return rows;

        return [...rows].sort((a, b) => {
            const aVal = a[sort.fieldName] || '';
            const bVal = b[sort.fieldName] || '';
            
            const result = aVal.toString().localeCompare(bVal.toString(), 'ru', { numeric: true });
            return sort.order === 'asc' ? result : -result;
        });
    }, [rows, sort]);

    const allSelected = canDeleteRows && selectedIds.length > 0 && selectedIds.length === rows.length;

    return (
        <div style={{position: 'relative', display: 'inline-block', minWidth: '100%'}}>
            <TableStyled striped={true}>
                <Table.Header style={{
                    position: 'sticky',
                    top: 0,
                    zIndex: 101,
                    backgroundColor: '#fff'
                }}>
                    <Table.Row>
                        {canDeleteRows && (
                            <Table.HeaderCell className='table-grid__checkbox' style={{backgroundColor: '#fff'}}>
                                <Checkbox
                                    checked={allSelected}
                                    onChange={(e, {checked}) => onSelectAll(checked)}
                                />
                            </Table.HeaderCell>
                        )}
                        <Table.HeaderCell style={{minWidth: '60px', textAlign: 'center', backgroundColor: '#fff'}}>
                            Ошибки
                        </Table.HeaderCell>
                        {columns.map(col => (
                            <Table.HeaderCell key={col.fieldName} style={{minWidth: col.minWidth, backgroundColor: '#fff'}}>
                                <div className='table-grid__filter'>
                                    <span>{col.title}</span>
                                    {!col.disableSort && (
                                        <div 
                                            className='table-grid__sort-btn'
                                            onClick={() => handleSort(col.fieldName)}
                                            style={{cursor: 'pointer', marginLeft: '5px'}}
                                        >
                                            <SortIcon
                                                highlighted={sort && sort.fieldName === col.fieldName}
                                                isAsc={sort && sort.fieldName === col.fieldName && sort.order === 'asc'}
                                            />
                                        </div>
                                    )}
                                </div>
                            </Table.HeaderCell>
                        ))}
                        <Table.HeaderCell style={{minWidth: '80px', textAlign: 'center', backgroundColor: '#fff'}}>
                            Места
                        </Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {sortedRows.map(row => {
                        const isSelected = selectedIds.includes(row.id);
                        const hasErrors = !row.isValid;
                        const errorCount = row.invalidFields ? row.invalidFields.length : 0;
                        
                        return (
                            <Table.Row 
                                key={row.id}
                                className={hasErrors ? 'table-grid__row table-grid__row_red' : 'table-grid__row'}
                            >
                                {canDeleteRows && (
                                    <Table.Cell className='table-grid__checkbox_row'>
                                        <Checkbox 
                                            checked={isSelected}
                                            onChange={(e, {checked}) => onSelectChange(row.id, checked)}
                                        />
                                    </Table.Cell>
                                )}
                                <Table.Cell style={{textAlign: 'center'}}>
                                    {hasErrors ? (
                                        <span 
                                            className="error-badge" 
                                            title={row.validationErrors}
                                            style={{
                                                backgroundColor: '#dc3545',
                                                color: '#fff',
                                                padding: '2px 6px',
                                                borderRadius: '10px',
                                                fontSize: '11px',
                                                fontWeight: 'bold'
                                            }}
                                        >
                                            {errorCount}
                                        </span>
                                    ) : (
                                        <span style={{color: '#28a745', fontWeight: 'bold'}}>✓</span>
                                    )}
                                </Table.Cell>
                                {columns.map(col => {
                                    // Определяем поля, которые должны переноситься по словам
                                    const shouldWrap = col.fieldName.includes('Address') || 
                                                      col.fieldName === 'cargoDescription' || 
                                                      col.fieldName.includes('Comment') ||
                                                      col.fieldName.includes('Company') ||
                                                      col.fieldName.includes('ContactPerson') ||
                                                      col.fieldName === 'initiator';
                                    
                                    return (
                                    <Table.Cell 
                                        key={col.fieldName}
                                        style={{
                                            maxWidth: col.maxWidth, 
                                            minWidth: col.minWidth,
                                            whiteSpace: shouldWrap ? 'normal' : 'nowrap',
                                            wordWrap: 'break-word',
                                            overflowWrap: 'break-word'
                                        }}
                                    >
                                        <TableCellValueMassUpload
                                            column={col}
                                            row={row}
                                            allParcels={allParcels}
                                            fileId={fileId}
                                            reload={reload}
                                            onBeforeOpen={onBeforeEditOpen}
                                            onSave={onSaveEdit}
                                        />
                                    </Table.Cell>
                                    );
                                })}
                                <Table.Cell style={{textAlign: 'center'}}>
                                    <button 
                                        className="btn btn-xs btn-default" 
                                        onClick={() => onEditPositions(row.id)}
                                        title="Редактировать места"
                                    >
                                        <i className="fa fa-edit"></i> Места
                                    </button>
                                </Table.Cell>
                            </Table.Row>
                        );
                    })}
                </Table.Body>
            </TableStyled>
            
            {loading && (
                <div 
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(255, 255, 255, 0.8)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 100
                    }}
                >
                    <i className="fa fa-spinner fa-spin fa-2x text-primary"></i>
                </div>
            )}
        </div>
    );
};

export default MassUploadTableGrid;




// WEBPACK FOOTER //
// ./App/pages/massUpload/components/MassUploadTableGrid.jsx